import React from 'react';

import config from '~/config/article';
import CoronaMap from './MapWrapper';

const Map = ({
  data,
  bbox,
  date,
  maxValue,
  mapAttribution = config.map.attribution,
  attributionPrefix = '',
  isMainMap = false,
  ...rest
}) => (
  <CoronaMap
    minZoom={config.map.minZoom}
    maxZoom={config.map.maxZoom}
    fitBounds={bbox}
    maxBounds={[
      [-90, -180],
      [90, 180],
    ]}
    data={data}
    maxValue={maxValue}
    showBasemap
    basemapUrl={config.map.basemap}
    basemapAttribution={mapAttribution}
    attributionPrefix={attributionPrefix}
    showLabels
    customLabels={[]}
    smoothFactor={0.5}
    zoomSnap={1}
    zoomDelta={1}
    tileSize={256}
    zoomOffset={0}
    showMapToggleButton={false}
    date={date}
    isMainMap={isMainMap}
    {...rest}
  />
);

export default Map;
